import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ModalService } from '@shopping-angular-components/modal';
import { Messages } from 'projects/common/services/messages.service';
import { UpaService, UpaTarget } from 'projects/common/services/upa.service';
import { OfferCardDataAlternative } from '../offer-card-data.model';

@Component({
  selector: 'selectable-dates',
  template: `
    <div class="modal-header -show">

      <div class="modal-header-component" [ngStyle]="{width: '100%'}">
        <div class="-picture-container">
          <span class="-img"></span>
          <i class="modal-close eva-3-icon-cross" (click)="close()"></i>
          <i class="modal-arrow-close eva-3-h4 eva-3-icon-cross" (click)="close()"></i>
        </div>
        <div class="-eva-3-tl">
          <h3 class="modal-title eva-3-h3">{{title}}</h3>
          <p class="modal-text -eva-3-mt-sm">{{text}}</p>
        </div>
      </div>
    </div>
    <div class="selectable-dates -no-gutter eva-3-body-2">
      <a [href]="offer.link.url" target="_blank" [title]="offer.link.title" class="date-box"
         *ngFor="let offer of offers; let i = index" (click)="trackSelection(offer, i)">
        <div class="date-container eva-3-card eva-3-row -eva-3-shadow-line">
          <div class="date-container__nights col -sm-12">{{offer.outstanding_text}}</div>
          <div class="date-container__date date-container__from-date col -sm-6">{{offer.date_label_from}}</div>
          <div class="date-container__date col -sm-6">{{offer.date_label_to}}</div>
          <div class="date-container__price col -sm-12">{{offer.price[currency].currency_mask}}<span class="eva-3-h3">
              {{offer.price[currency].total_amount}}</span></div>
        </div>
      </a>
    </div>
    <div class="eva-3-view-more" *ngIf="showSeeMore()">
      <a class="eva-3-p view-more-btn-text" [href]="viewMoreLink" target="_blank">{{messages.seeOtherDates}}</a>
    </div>
  `,
  styleUrls: ['./selectable-dates.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class SelectableDatesComponent implements OnInit {
  @Input() offers: OfferCardDataAlternative[];
  @Input() messages: Messages;
  @Input() currency: string;
  @Input() offerType: string;
  @Input() viewMoreLink: string;
  @Input() moduleId: string;
  @Input() moduleIndex: number;
  @Input() uniqueId?: string;
  @Input() product: string;
  title: string;
  text: string;

  constructor(private upaService: UpaService, private modalService: ModalService) { }

  ngOnInit() {
    if (this.offerType === 'PACKAGES') {
      if (this.offers.length > 1) {
        this.title = this.messages.offersFound;
        this.text = this.messages.bestPricesForPackage;
      } else {
        this.title = this.messages.offerFound;
        this.text = this.messages.bestPriceForPackage;
      }
    } else {
      this.title = this.messages.selectYourDate;
    }
  }

  showSeeMore(): boolean {
    return !!this.viewMoreLink && this.viewMoreLink !== "" &&  this.offerType === "PACKAGES";
  }

  trackSelection(offer: OfferCardDataAlternative, index: number) {
    this.upaService.trackClickTopic({
      label: this.product,
      moduleId: this.moduleId,
      moduleIndex: this.moduleIndex,
      positionIndex: index,
      target: UpaTarget.OFFER,
      href: offer.link.url,
      uniqueId: this.uniqueId
    });
  }

  close() {
    this.modalService.closeModal();
  }
}
